import { XIColors } from '@inmoment/the-kitchen';
import React from 'react';

export const expCardDataObject = (
  <>
    {'export const experienceCardComment = {'}
    <br />
    &nbsp;&nbsp;
    <span style={{ color: XIColors.red.primary, fontWeight: 600 }}>sqlId: '201432978', // PROPERTY NOT NEEDED</span>
    <br />
    <span style={{ color: XIColors.red.primary, fontWeight: 600 }}>
      &nbsp;&nbsp;dataFieldId: '17102457', // PROPERTY NOT NEEDED
      <br />
      &nbsp;&nbsp;dataFieldLabel: 'OSAT Comment (Yes / No)', // PROPERTY NOT NEEDED
    </span>
    <br />
    &nbsp;&nbsp;{`externalId: 'anyExternalId',`}
    <br />
    &nbsp;&nbsp;{`answerId: 'id',`}
    <br />
    &nbsp;&nbsp;{`promptLabel: 'How was your overall experience?',`}
    <br />
    &nbsp;&nbsp;
    {`text: 'Danielle Hinson and Crystal McAdams provided awesome customer service. This was the best refi experience ever and I have had several. Will highly recommend Insight.',`}
    <br />
    &nbsp;&nbsp;{`sentimentScore: 27,`}
    <br />
    &nbsp;&nbsp;{`sentimentConfidence: 0.55,`}
    <br />
    &nbsp;&nbsp;{`sentimentBarExpanded: true,`}
    <br />
    &nbsp;&nbsp;
    <span style={{ color: XIColors.green.primary, fontWeight: 600 }}>showMoreMomentsLink: true, // PROPERTY ADDED</span>
    <br />
    &nbsp;&nbsp;{`sentimentAnnotations: [`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`{`}
    <br />
    <span style={{ color: XIColors.red.primary, fontWeight: 600 }}>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sqlId: '8502875', // PROPERTY NOT NEEDED
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tagIds: [], // PROPERTY NOT NEEDED
    </span>
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentiment: 1,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentimentId: '1234',`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`beginIndex: 133,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`endIndex: 164,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentimentScore: 48,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    {`sentimentConfidence: 0.9803093671798706`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`},`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`{`}
    <br />
    <span style={{ color: XIColors.red.primary, fontWeight: 600 }}>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sqlId: '8502875', // PROPERTY NOT NEEDED
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tagIds: [], // PROPERTY NOT NEEDED
    </span>
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentiment: 0,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentimentId: '12345,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`beginIndex: 70,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`endIndex: 132,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentimentScore: 63,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    {`sentimentConfidence: 0.9937220215797424`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`},`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`{`}
    <br />
    <span style={{ color: XIColors.red.primary, fontWeight: 600 }}>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;sqlId: '8502875', // PROPERTY NOT NEEDED
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;tagIds: [], // PROPERTY NOT NEEDED
    </span>
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentiment: -1,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentimentId: 123456,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`beginIndex: 0,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`endIndex: 69,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentimentScore: 81,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
    {`sentimentConfidence: 0.9992719292640686`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`}`}
    <br />
    &nbsp;&nbsp;{`]`}
    <br />
    &nbsp;&nbsp;{`tagAnnotations: [`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`{`}
    <br />
    <span style={{ color: XIColors.red.primary, fontWeight: 600 }}>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;annotation: 'Personnel', // PROPERTY NOT NEEDED
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;category: 'Personnel', // PROPERTY NOT NEEDED
    </span>
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentiment: 1,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`tagId: '19481',`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`beginIndex: 84,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`endIndex: 104,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`tag: 'General Service,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`},`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`{`}
    <br />
    <span style={{ color: XIColors.red.primary, fontWeight: 600 }}>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;annotation: 'Personnel', // PROPERTY NOT NEEDED
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;category: 'Personnel', // PROPERTY NOT NEEDED
    </span>
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentiment: -1,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`tagId: '20650',`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`beginIndex: 20,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`endIndex: 27,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`tag: 'Mentions Name,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`},`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`{`}
    <br />
    <span style={{ color: XIColors.red.primary, fontWeight: 600 }}>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;annotation: 'Personnel', // PROPERTY NOT NEEDED
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;category: 'Personnel', // PROPERTY NOT NEEDED
    </span>
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentiment: 0,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`tagId: '23136',`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`beginIndex: 53,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`endIndex: 69,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`tag: 'Customer Support,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`},`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`{`}
    <br />
    <span style={{ color: XIColors.red.primary, fontWeight: 600 }}>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;annotation: 'Personnel', // PROPERTY NOT NEEDED
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;category: 'Personnel', // PROPERTY NOT NEEDED
    </span>
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentiment: 1,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`tagId: '19481',`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`beginIndex: 45,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`endIndex: 69,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`tag: 'General Service,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`},`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`{`}
    <br />
    <span style={{ color: XIColors.red.primary, fontWeight: 600 }}>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;annotation: 'Personnel', // PROPERTY NOT NEEDED
      <br />
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;category: 'Personnel', // PROPERTY NOT NEEDED
    </span>
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`sentiment: 1,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`tagId: '22230',`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`beginIndex: 0,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`endIndex: 8,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{`tag: 'Mentions Name,`}
    <br />
    &nbsp;&nbsp;&nbsp;&nbsp;{`},`}
    <br />
    &nbsp;&nbsp;{`]`}
    <br />
    &nbsp;&nbsp; audioSrcUrl: '../path'
    <br />
    &nbsp;&nbsp; imageSrcUrl: '../path'
    <br />
    &nbsp;&nbsp; videoSrcUrl: '../path'
    <br />
    {'}'}
  </>
);
